

import React, { useEffect, useState } from 'react';
// import './TechnologySection.css';

const techData = [
    // INNER CIRCLE (7 Logos)
    { name: "ReactJs", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg", type: "inner" },
    { name: "Node.js", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original-wordmark.svg", type: "inner" }, 
    { name: "MS SQL", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/microsoftsqlserver/microsoftsqlserver-plain.svg", type: "inner" },
    { name: "MongoDB", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg", type: "inner" },
    { name: "PHP", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg", type: "inner" },
    { name: ".NET Core", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dotnetcore/dotnetcore-original.svg", type: "inner" },
    { name: "VB.NET", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/visualstudio/visualstudio-plain.svg", type: "inner" },

    // OUTER CIRCLE (8 Logos)
    { name: "Flutter", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg", type: "outer" },
    { name: "Azure", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-original.svg", type: "outer" },
    { name: "Oracle", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/oracle/oracle-original.svg", type: "outer" },
    { name: "Figma", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg", type: "outer" },
    { name: "Android Studio", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/androidstudio/androidstudio-original.svg", type: "outer" },
    { name: "Bootstrap", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg", type: "outer" },
    { name: "Next.Js", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg", type: "outer" },
    { name: "IBM DB2", icon: "/assets/img/ibm.png", type: "outer" }, 
];

const TechnologySection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setIsVisible(true);
    }, { threshold: 0.3 });
    const element = document.querySelector('.technology-section-container');
    if (element) observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return (
    <div className={`technology-section-container ${isVisible ? 'start-animation' : ''}`}>
     <div className="tech-heading-wrapper">
        <h2 className="tech-title">Our Core <span className="blue-gradient">Technologies</span></h2>
        <div className="tech-underline"></div>
      </div>

      <div className="animated-logos">
<div className="logo-main">
  <div className="main-circle">
    <img 
      src="/assets/img/Galaxylogo1-removebg.png" 
      alt="Galaxy Logo" 
      className="center-brand-logo" 
    />
  </div>
</div>

        <div className="section-connectors">
           <div className="ring ring-inner"></div>
           <div className="ring ring-outer"></div>
        </div>

        {/* ઈનર ઓર્બિટ લોજિક */}
        <div className="orbit-inner">
          {techData.filter(t => t.type === "inner").map((tech, index) => {
            const angle = (index * 360) / 7;
            return (
              <div key={index} className="logo-node inner" style={{ '--angle': `${angle}deg` }}>
                <div className="icon-wrapper">
                  <img src={tech.icon} alt={tech.name} />
                  <span className="tech-name">{tech.name}</span>
                </div>
              </div>
            );
          })}
        </div>

        {/* આઉટર ઓર્બિટ લોજિક */}
        <div className="orbit-outer">
          {techData.filter(t => t.type === "outer").map((tech, index) => {
            const angle = (index * 360) / 8;
            return (
              <div key={index} className="logo-node outer" style={{ '--angle': `${angle}deg` }}>
                <div className="icon-wrapper">
                  <img src={tech.icon} alt={tech.name} />
                  <span className="tech-name">{tech.name}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TechnologySection;